export default {"src":"/_next/static/media/shield.39688124.svg","height":97,"width":96};